// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkboxes[data-v-f86a189c]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[dir] .checkbox[data-v-f86a189c]{margin:8px 0}", ""]);
// Exports
module.exports = exports;
